import React from "react";
import { NavLink } from "react-router-dom";
import {
  FiExternalLink,
  FiGrid,
  FiUsers,
  FiSettings,
  FiLogOut,
  FiX,
} from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../store/uiSlice";
import styles from "./AdminSidebar.module.css";

const links = [
  { to: "/admin/dashboard", label: "Dashboard", icon: FiGrid },
  { to: "/admin/users", label: "Users", icon: FiUsers },
  {
    to: "/admin/profile-settings",
    label: "Profile Settings",
    icon: FiSettings,
  },
];

export default function AdminSidebar({ open = false, onClose }) {
  const dispatch = useDispatch();

  return (
    <aside className={`${styles.sidebar} ${open ? styles.open : ""}`}>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close menu"
      >
        <FiX />
      </button>
      <div className={styles.brand}>
        <img src="/logo/rcmLogo.webp" alt="RCM Portal" />
      </div>
      <nav className={styles.nav}>
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `${styles.link} ${isActive ? styles.active : ""}`
            }
            onClick={onClose}
          >
            <Icon />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className={styles.bottom}>
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.visit}
        >
          <FiExternalLink />
          <span>Visit Website</span>
        </a>
        <button
          type="button"
          className={`${styles.logout} btnBase btnDanger`}
          onClick={() =>
            dispatch(
              openModal({
                name: "confirmLogout",
                props: {
                  title: "Logout from admin?",
                  message: "You will need to sign in again to continue.",
                },
              }),
            )
          }
        >
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}
